<template>
    <div class="col p-0">
        <div style="padding: 1em" class="col-12 pb-4 d-flex align-items-center">
            <div class="col col-4">
                <cc-search v-model="filters.name" :placeholder="'Filtrar por nome'" />
            </div>
            <div class="col">
                <toggle-button v-model="filters.attending" :color="'#ff7110'" :height="30" />
                Em atendimento
            </div>
            <StandardButton :action="() => $emit('close')" text="Voltar" />
            <StandardButton
                v-if="selectedClients.length > 0"
                class="ml-2"
                :action="unlinkSelectedClients"
                text="Desvincular selecionados"
                color="red"
            />
        </div>
        <div class="col p-0">
            <cc-loader v-show="loading" />
            <no-data-available v-if="!loading && clients && clients.length == 0" :text="'Nenhum cliente em atendimento'" />
            <div v-show="!loading && clients && clients.length > 0">
                <div class="page-table-content">
                    <div class="page-table-header">
                        <div class="page-table-header-text name-width">Nome</div>
                        <div class="page-table-header-text group-width">Grupo</div>
                        <div class="page-table-header-text phone-width">Telefone</div>
                        <div class="page-table-header-text participation-width">Participação</div>
                        <div class="page-table-header-text checkbox-width">Selecionar</div>
                        <div class="page-table-header-text active-width">Ativo</div>
                    </div>
                    <div v-for="(client, idx) in clients" :key="client.id" :class="getSpecialBackground(idx)">
                        <div class="page-table-row">
                            <div @click="setSearch(client.group_name)" class="page-table-desc-column name-width name-special">
                                {{ client.name }}
                            </div>
                            <div class="page-table-desc-column group-width">
                                {{ client.group_name }}
                            </div>
                            <div class="page-table-desc-column phone-width">
                                <cc-whatsapp :phone="client.phone" />
                            </div>
                            <div class="page-table-desc-column participation-width">
                                <cc-percentage
                                    v-if="client.sellers && client.sellers.length > 0"
                                    :value="client.sellers[0].pivot.participation"
                                />
                            </div>
                            <div class="page-table-desc-column checkbox-width">
                                <input type="checkbox" v-model="selectedClients" :value="client.id" class="form-check-inputs" />
                            </div>
                            <div class="page-table-desc-column active-width">
                                <toggle-button
                                    :value="client.is_attending"
                                    @change="toggle_client(client)"
                                    :sync="true"
                                    :color="'#ff7110'"
                                    :height="20"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div v-show="total_items > 15">
                    <Pagination
                        classes="orange justify-end"
                        :total="total_items"
                        :items_by_page_value="items_by_page_value"
                        :page="page"
                        :page_limit="9"
                        v-on:change="
                            ($event) => {
                                load_available_clients($event);
                                return $event;
                            }
                        "
                    >
                    </Pagination>
                </div>
            </div>

            <!-- <table class="table" v-show="!loading && clients && clients.length > 0">
                <thead>
                    <tr>
                        <th class="pl-2">Nome</th>
                        <th>Grupo</th>
                        <th>Telefone</th>
                        <th>Participação</th>
                        <th>Ativo</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="client in clients" v-bind:key="client.id">
                        <td>{{ client.name }}</td>
                        <td class="text-uppercase">{{ client.group_name }}</td>
                        <td><cc-whatsapp :phone="client.phone" /></td>
                        <td>
                            <cc-percentage v-if="client.sellers && client.sellers.length > 0"
                                :value="client.sellers[0].pivot.participation" />
                        </td>
                        <td>
                            <toggle-button
                                :value="client.is_attending"
                                @change="toggle_client(client)"
                                :sync="true"
                                :color="'#ff7110'"
                                :height="20"/>
                        </td>
                    </tr>
                    <tr v-show="total_items > 15">
                        <td colspan="4">
                            <Pagination
                                classes="orange justify-end"
                                :total="total_items"
                                :items_by_page_value="items_by_page_value"
                                :page="page"
                                :page_limit="9"
                                v-on:change="($event) => {
                                    load_available_clients($event)
                                    return $event
                                }"
                            ></Pagination>
                        </td>
                    </tr>
                </tbody>
            </table> -->
        </div>
    </div>
</template>

<script>
import SellerService from "@/services/v3/providers/seller.service";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import Pagination from "@/components/cliente/base-components/Pagination";
import StandardButton from "../../../components/ui/buttons/StandardButton.vue";

export default {
    props: ["sellerId", "setSearch"],
    components: {
        Pagination,
        StandardButton,
    },
    data() {
        return {
            page: 1,
            items_by_page_value: 10,
            loading: false,
            svc: new SellerService(),
            clients: [],
            filters: {
                attending: true,
            },
            total_items: 0,
            selectedClients: [],
        };
    },
    watch: {
        filters: {
            handler: function() {
                this.page = 1;
                this.load_available_clients();
            },
            deep: true,
        },
        sellerId() {
            this.load_available_clients();
        },
    },
    methods: {
        getSpecialBackground(idx) {
            if (idx % 2 != 0) return "page-table-line-special";
        },
        toggle_client(client) {
            this.svc.toggle_client(client, this.sellerId).then((resp) => {
                this.load_available_clients();
            });
        },
        load_available_clients(page = this.page) {
            this.loading = true;
            let params = {
                ...this.filters,
                page: page,
                per_page: this.items_by_page_value,
            };

            return this.svc
                .available_clients(this.sellerId, params)
                .then((response) => response.data)
                .then((data) => {
                    this.total_items = data.meta.total;
                    this.clients = data.data;
                    this.selectedClients = this.selectedClients.filter((selectedId) =>
                        data.data.some((client) => client.id === selectedId)
                    );
                })
                .catch((err) => {
                    ErrorHandlerService.handle(err, this.$store);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        async unlinkSelectedClients() {
            if (this.selectedClients.length === 0) return;

            try {
                const confirmed = await this.$swal.fire({
                    title: "Tem certeza?",
                    text: `Você está prestes a desvincular ${this.selectedClients.length} cliente(s) deste vendedor.`,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#ff7110",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim, desvincular!",
                    cancelButtonText: "Cancelar",
                });

                if (!confirmed.isConfirmed) return;

                this.loading = true;

                await this.svc.deactivateMultipleClients(this.sellerId, this.selectedClients);

                this.removeUnlinkedClients(this.selectedClients);

                this.$toast.success(`${this.selectedClients.length} cliente(s) desvinculado(s) com sucesso!`);

                this.selectedClients = [];
            } catch (error) {
                console.error("Erro na desvinculação:", error);
                this.$toast.error(this.getErrorMessage(error));
            } finally {
                this.loading = false;
            }
        },

        removeUnlinkedClients(idsToRemove) {
            const idsSet = new Set(idsToRemove);
            this.clients = this.clients.filter((client) => !idsSet.has(client.id));
            this.total_items = Math.max(0, this.total_items - idsToRemove.length);
        },

        getErrorMessage(error) {
            if (error.response) {
                return error.response.data.message || "Erro ao processar a solicitação";
            }
            return "Erro de conexão. Verifique sua internet e tente novamente.";
        },
        confirm_action({ message, callback }) {
            this.$swal
                .fire({
                    title: "Confirmação",
                    text: message,
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonText: "Confirmar",
                    cancelButtonText: "Cancelar",
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        callback();
                    }
                });
        },
    },
    mounted() {
        this.load_available_clients();
    },
};
</script>

<style lang="scss">
@import "@/sass/commons/_variables";

.page-table-header {
    background: #fffefc;
    border: 0.5px solid #e5e5e5;
    font-weight: 400;
    color: #605f5f;
    display: flex;
    padding: 1em 0em;
}

.page-table-header-text {
    padding-left: 10px;
    font-weight: 600;
    font-size: 1.19em;
    color: #505050;
}

.page-table-row {
    display: flex;
    font-weight: 300;
    font-size: 1.2em;
    color: #605f5f;
    align-items: center;
}

.page-table-desc-column {
    padding: 0.5em 0.7em;
    text-align: left;
    display: flex;
    align-items: center;
}

.page-table-line-special {
    background: #f7f7f7;
}
.name-width {
    width: 30%;
}
.group-width {
    width: 20%;
}
.phone-width {
    width: 15%;
}
.participation-width {
    width: 12%;
}

.checkbox-width {
    width: 12%;
}
.active-width {
    width: 10%;
}
.name-special {
    cursor: pointer;
    &:hover {
        text-decoration: underline;
    }
}
.form-check-inputs {
    width: 20px;
    height: 20px;
    margin-left: 2rem;
    cursor: pointer;
    appearance: none;
    -webkit-appearance: none;
    border: 2px solid #221c1c;
    border-radius: 4px;
    outline: none;
    transition: all 0.3s ease;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    &:checked {
        background-color: var(--primary-color);
        border-color: var(--primary-color);
    }

    &:focus {
        box-shadow: 0 0 0 0.25rem rgba(var(--primary-color-rgb), 0.25);
    }
}
</style>
